import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../redux/slices/admin/operations';
import styles from './Login.module.scss';

export const LoginPage = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { isLoading, message } = useSelector(state => state.admin ?? {});

  const handleSubmit = event => {
    event.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <div className={styles.wrapper}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <h1 className={styles.title}>Admin Login</h1>
        <p className={styles.subtitle}>Sign in to manage your application.</p>

        <label className={styles.field}>
          Email
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="admin@example.com"
            className={styles.input}
          />
        </label>

        <label className={styles.field}>
          Password
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="••••••••"
            className={styles.input}
          />
        </label>

        {message && <p className={styles.error}>{message}</p>}

        <button type="submit" disabled={isLoading} className={styles.button}>
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};
